export const VERSION_CHECKER_TEXTS = {
	NEW_VERSION_AVAILABLE:
		"New version available, please click refresh to update.",
	DISMISS: "Dismiss",
	REFRESH: "Refresh",
	DISMISS_ACCESSIBILITY_LABEL: "Dismiss update notification",
	REFRESH_ACCESSIBILITY_LABEL: "Refresh to update app",
} as const;
